// Haptic ticks via the Vibration API (Android Chrome/Firefox; iOS Safari has none).
// Why a tick can be silent although vibrate() returns true (Chromium VibrationManagerAndroid):
//  - Chrome skips the motor entirely while the ringer is in silent mode (RINGER_MODE_SILENT);
//  - Android 13+ also mutes it when system touch vibration is off;
//  - very short pulses (< ~12 ms) are below what many linear motors render.
// vibrate() returns false only when Blink blocks it: no sticky user activation yet, hidden page,
// cross-origin or fenced frame. No HTTP header or Permissions-Policy is involved.
export const TICK_MS = 15, MIN_GAP_MS = 35;
export const status = {calls: 0, last: null, blocked: 0, skipped: 0};

export function haptic(ms = TICK_MS, {nav = globalThis.navigator, now = () => globalThis.performance?.now?.() ?? Date.now()} = {}) {
  if (typeof nav?.vibrate !== 'function') { status.last = 'unsupported'; return false; }
  // A fast drag can cross several detents per frame; one tick per gap keeps them distinct.
  const time = now();
  if (status.at !== undefined && time - status.at < MIN_GAP_MS) { status.skipped++; return false; }
  status.at = time; status.calls++;
  let result;
  try { result = nav.vibrate(ms); } catch { result = false; }
  status.last = result; if (!result) status.blocked++;
  return result;
}

